import select from 'dom-select';

export const MenuToggle = (el) => {
  const ui = {
    el,
    nav: select('.js-navigation', document),
    body: select('body', document),
  };

  // console.log(ui);

  const handleToggle = () => {
    const isActive = ui.el.classList.contains('is-active');
    ui.el.classList.toggle('is-active');
    ui.el.setAttribute('aria-expanded', String(!isActive));

    if (ui.nav) {
      ui.nav.classList.toggle('is-active');
    }
    if (ui.body) {
      ui.body.classList.toggle('nav-open');
    }
  };

  const addEvents = () => {
    ui.el.addEventListener('click', () => {
      handleToggle();
    });
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default MenuToggle;
